import { useQuery } from "@tanstack/react-query";
import useMutationWithInvalidation from "neetocommons/react-utils/useMutationWithInvalidation";

import allowedIpRangesApi from "../../apis/allowed_ip_ranges";
import { QUERY_KEYS } from "../../constants";

const { ALLOWED_IP_RANGES } = QUERY_KEYS;

const useFetchAllowedIpRanges = options =>
  useQuery({
    queryKey: [ALLOWED_IP_RANGES],
    queryFn: () => allowedIpRangesApi.fetch(),
    ...options,
  });

const useCreateAllowedIpRanges = () =>
  useMutationWithInvalidation(allowedIpRangesApi.create, {
    keysToInvalidate: [[ALLOWED_IP_RANGES]],
  });

const useDestroyAllowedIpRanges = () =>
  useMutationWithInvalidation(allowedIpRangesApi.destroy, {
    keysToInvalidate: [[ALLOWED_IP_RANGES]],
  });

const useUpdateAllowedIpRanges = () =>
  useMutationWithInvalidation(allowedIpRangesApi.update, {
    keysToInvalidate: [[ALLOWED_IP_RANGES]],
  });

export {
  useFetchAllowedIpRanges,
  useCreateAllowedIpRanges,
  useDestroyAllowedIpRanges,
  useUpdateAllowedIpRanges,
};
